import {
  OrderStatus as OrderStatusType,
  StructureStatus as StructureStatusType,
} from "@providers/hop-ord-server/api";
import { PaletteColour } from "../theme/theme";

export enum Feature {
  COMMAND_CENTER_CREATE_ORDER = "command_center_create_order",
  PLAN_REVIEW = "plan_review_page",
  SHOW_LINK_TO_LUMONUS_AI = "lai_redirect",
  SHOW_DVH = "show_dvh",
  IGUANA_INTEGRATION = "iguana_integration",
  MULTIPLE_RT_STRUCTURES = "multiple_rt_structures",
  SELECT_ISOCENTER = "select_isocenter",
}

export enum Role {
  RO = "role:ro",
  DOSIMETRIST = "role:planner",
  ADMIN = "admin:lumonus-planning",
  AUTOMATION_DEPLOYMENT = "role:automation-deployment",
  METRICS = "role:view-metrics",
}

export enum ListDataCategory {
  TREATMENT_SITE = "treatmentSite",
  ISODOSE = "isodose",
  LATERALITY = "laterality",
  TECHNIQUE = "technique",
  SEQUENCE = "sequence",
  FREQUENCY = "frequency",
  ENERGY = "energy",
  ORGAN = "organ",
  REJECT_REASON = "reject_reason",
  TREATING_DEPARTMENT = "treating_department",
  MACHINE = "machine",
}

export enum PlanningStatus {
  DRAFT = "Draft",
  NEW_CAREPLAN = "Not ready for planning",
  READY_FOR_PLANNING = "Ready for planning",
  PLANNING = "Planning",
  PENDING_PLAN_REVIEW = "Pending plan review",
  APPROVED = "Approved",
  REJECTED = "Rejected",
  HANDOVER_COMPLETE = "Handover complete",
}

export const DASH_EMPTY_FIELD = "-";

export const OrderStatus: Record<string, OrderStatusType> = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  IN_PROGRESS: "in_progress",
  READY_FOR_RO_APPROVAL: "ready_for_ro_approval",
  APPROVED: "approved",
  REJECTED: "rejected",
  COMPLETED: "completed",
  SENT_TO_AUTOMATION: "sent_to_automation",
  MANUAL_PLAN: "manual_plan",
};

export const orderStatusMapping: { [key in OrderStatusType]: string } = {
  draft: "Draft",
  submitted: "Submitted",
  in_progress: "In Progress",
  ready_for_ro_approval: "Ready for RO approval",
  approved: "Approved",
  rejected: "Rejected",
  completed: "Completed",
  sent_to_automation: "Sent to Automation",
  manual_plan: "Manual Plan",
};

export const orderStatusColourMapping: {
  [key in OrderStatusType]: PaletteColour;
} = {
  draft: "default",
  submitted: "secondary",
  in_progress: "info",
  ready_for_ro_approval: "warning",
  approved: "success",
  rejected: "error",
  completed: "primary",
  sent_to_automation: "success",
  manual_plan: "success",
};

export const StructureStatus: Record<string, StructureStatusType> = {
  COMPLETE: "complete",
  PENDING: "pending",
  SKIPPED: "skipped",
};

export const planningStatusColourMapping: {
  [key in PlanningStatus]: string;
} = {
  [PlanningStatus.DRAFT]: "grey.200",
  [PlanningStatus.NEW_CAREPLAN]: "action.selected",
  [PlanningStatus.READY_FOR_PLANNING]: "info.light",
  [PlanningStatus.PLANNING]: "secondary.main",
  [PlanningStatus.PENDING_PLAN_REVIEW]: "warning.main",
  [PlanningStatus.APPROVED]: "success.main",
  [PlanningStatus.REJECTED]: "error.main",
  [PlanningStatus.HANDOVER_COMPLETE]: "success.main",
};

export enum NotificationType {
  ORDER_STATUS = "ORDER_STATUS",
  NEW_COMMENT = "NEW_COMMENT",
}

// Add to this when necessary
export enum RT_ROI_TYPE {
  ISOCENTER = "ISOCENTER",
  MARKER = "MARKER",
  PTV = "PTV",
  CTV = "CTV",
  ORGAN = "ORGAN",
  STRUCTURE = "STRUCTURE",
}
